<script>

    import { toast } from 'bulma-toast'
    import { ticketStore } from '../stores'

    import DateMethod from '../$methods/date.method'
    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'
    import Subtitle from '../$components/subtitle.svelte'

    import Button from '../$components/button.svelte'
    import ButtonModal from '../$components/button.modal.svelte'

    let inputs = {}

    function onCopy(prop) {
        inputs[prop].select()
        inputs[prop].setSelectionRange(0, 99999)
        document.execCommand("copy")
        toast({message: 'Link copiado', type: 'is-success'})
    }

</script>

{#if $ticketStore}

    <DetailsCard
        title={$ticketStore.code || 'Ticket'}
        meta={DateMethod.dateTimeLarge($ticketStore.created)}
        statusValue={$ticketStore.status}
    >
        <DetailsFields>
            <DetailsField label="Usuario">
                <div>
                    <div><b>{ $ticketStore.user.name }</b></div>
                    <div>{ $ticketStore.user.email }</div>
                </div>
            </DetailsField>
            <DetailsField label="Guía" value={$ticketStore.shipment.guide} />
            <DetailsField label="Fecha envío" value={DateMethod.dateTimeLarge($ticketStore.shipment.created)} />
        </DetailsFields>
        <div slot="footer">
            <div class="is-flex is-justify-content-flex-end is-align-items-center">
                <ButtonModal modalId="ticket_update_modal" icon="edit" text="Actualizar" />
            </div>
        </div>
    </DetailsCard>

    {#if $ticketStore.response}
        <div class="subtitle is-5">Respuesta</div>
        <div class="notification">{ $ticketStore.response }</div>
    {/if}

    {#if $ticketStore.history && $ticketStore.history.length}
        <Subtitle text="Historial" />
        <ul class="ticket-history-list">
            {#each $ticketStore.history as item}
                <li class="ticket-history-entry is-light">
                    <div>{ item.response }</div>
                    <small class="has-text-grey">{ DateMethod.dateLarge(item.created) }</small>
                </li>
            {/each}
        </ul>
    {/if}

    <div class="subtitle is-5">Datos</div>
    <DetailsCard title={$ticketStore.subject}>
        <DetailsFields>
            <DetailsField label="Detalles" value={$ticketStore.message} />
            {#each Object.keys($ticketStore.information || []) as prop }
                <DetailsField label={prop}>
                    <div class="is-flex is-justify-content-space-between is-align-items-center">
                        <input bind:this={inputs[prop]} type="text" value={$ticketStore.information[prop]} class="input" readonly>
                        <Button on:click={() => onCopy(prop)} icon="copy" tooltip="Copiar" />
                    </div>
                </DetailsField>
            {/each}
        </DetailsFields>
    </DetailsCard>
{/if}

